import DirectoryShowContainer from './directory_show_container';

const DirectoryShow = DirectoryShowContainer;
export default DirectoryShow;
